import { FunctionComponent } from 'react';

import { FormattedMessage } from 'dibs-react-intl';
import { RelativeDateFormat } from 'dibs-relative-date-format/exports/RelativeDateFormat';

// components
import { PriceAmount } from './PriceAmount';

type Props = {
    price?: number;
    currency: string;
    quantityDisplay: string | null;
    expiration: string | null;
    showExpirationDate: boolean;
};

export const PrivateOfferItemPrices: FunctionComponent<Props> = ({
    price,
    currency,
    expiration,
    showExpirationDate,
    quantityDisplay,
}) => {
    const formattedExpiration = showExpirationDate && expiration && (
        <RelativeDateFormat value={expiration} />
    );
    const expirationNode = showExpirationDate && (
        <FormattedMessage
            id="price.privateOfferExpires"
            defaultMessage="Expires {expiration}"
            values={{ expiration: formattedExpiration }}
        />
    );

    return (
        <PriceAmount
            type="PRIVATE_OFFER"
            currency={currency}
            amount={price}
            expiration={expirationNode}
            showLabel
            quantityDisplay={quantityDisplay}
        />
    );
};
